import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../components/layout/AppShell";
import api, { fmtMoney, fmtDate } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { ShoppingCart, Eye, Search, Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";

export default function PurchaseOrders() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [q, setQ] = useState("");
    const [status, setStatus] = useState("");
    useEffect(() => {
        api.get("/purchase-orders").then(r => setItems(r.data)).finally(() => setLoading(false));
    }, []);

    const filtered = items.filter(p => {
        if (status && p.status !== status) return false;
        if (!q) return true;
        const k = q.toLowerCase();
        return (p.number || "").toLowerCase().includes(k)
            || (p.supplier_name || "").toLowerCase().includes(k)
            || (p.project_name || "").toLowerCase().includes(k);
    });

    return (
        <AppShell title="Satın Alma Siparişleri" subtitle="Satın Alma">
            <div className="bg-card border border-border rounded-md">
                <div className="p-4 border-b border-border flex items-center gap-3 flex-wrap">
                    <div className="relative w-72">
                        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"/>
                        <Input data-testid="po-search" placeholder="Sipariş no, tedarikçi, proje..." value={q} onChange={(e)=>setQ(e.target.value)} className="pl-9"/>
                    </div>
                    <select
                        data-testid="po-status-filter"
                        className="h-10 border border-input rounded-md px-3 bg-background text-sm"
                        value={status} onChange={(e)=>setStatus(e.target.value)}
                    >
                        <option value="">Tüm durumlar</option>
                        <option value="draft">Taslak</option>
                        <option value="approved">Onaylı</option>
                        <option value="sent">Gönderildi</option>
                        <option value="partially_received">Kısmen Teslim</option>
                        <option value="completed">Tamamlandı</option>
                        <option value="cancelled">İptal</option>
                    </select>
                    <div className="text-xs text-muted-foreground ml-auto">{filtered.length} sipariş</div>
                </div>
                <div className="overflow-x-auto">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>No</th><th>Tarih</th><th>Tedarikçi</th><th>Proje</th>
                                <th className="text-right">Tutar</th><th className="text-center">Vade</th>
                                <th>Teslim</th><th>Durum</th><th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={9} className="text-center py-16 text-muted-foreground">
                                    <Loader2 size={22} className="mx-auto mb-2 animate-spin opacity-70"/>
                                    Yükleniyor...
                                </td></tr>
                            ) : filtered.map(p => (
                                <tr key={p.id} data-testid={`po-row-${p.number}`}>
                                    <td className="font-mono text-xs">{p.number}</td>
                                    <td>{fmtDate(p.date)}</td>
                                    <td className="font-medium">{p.supplier_name}</td>
                                    <td className="text-xs">{p.project_name}</td>
                                    <td className="text-right tabular-nums font-medium">{fmtMoney(p.total_amount, p.currency)}</td>
                                    <td className="text-center tabular-nums">{p.payment_term_days}g</td>
                                    <td>{fmtDate(p.delivery_date)}</td>
                                    <td><StatusBadge status={p.status}/></td>
                                    <td>
                                        <Link to={`/purchase-orders/${p.id}`}>
                                            <button className="inline-flex items-center gap-1.5 text-primary text-sm hover:underline" data-testid={`po-open-${p.number}`}>
                                                <Eye size={14}/> Aç
                                            </button>
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                            {!loading && filtered.length === 0 && (
                                <tr><td colSpan={9} className="text-center py-16 text-muted-foreground">
                                    <ShoppingCart size={28} className="mx-auto mb-2 opacity-40"/>
                                    {items.length === 0 ? "Henüz sipariş yok" : "Filtreye uyan sipariş yok"}
                                </td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AppShell>
    );
}
